import React, { useState } from 'react';
import { Form, Card, Button, Modal, Alert, Row, Col } from 'react-bootstrap';

const AddBookIssueForm = () => {
  const [formData, setFormData] = useState({
    book: '',
    user: ''
  });

  const [errors, setErrors] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    let formErrors = {};
    Object.keys(formData).forEach((field) => {
      if (!formData[field]) {
        formErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
      }
    });
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setTimeout(() => {
        const isSuccess = Math.random() > 0.5;
        if (isSuccess) {
          setShowSuccessModal(true);
        } else {
          setShowErrorModal(true);
        }
      }, 1000);
    }
  };

  return (
    <Card
      className="shadow-sm rounded-lg mx-auto p-4 d-flex flex-column justify-content-between"
      style={{ maxWidth: '850px', width: '100%', height: '500px' }}
    >
      <div>
        <h5 className="text-center mb-4">Add Book Issue</h5>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="book" className='mb-3  me-3 ms-3'> 
            <Form.Label>Book</Form.Label>
            <Form.Control
              as="select"
              name="book"
              value={formData.book}
              onChange={handleInputChange}
              isInvalid={!!errors.book}
            >
              <option value="">Select Book</option>
              <option value="Book 1">Book 1</option>
              <option value="Book 2">Book 2</option>
              <option value="Book 3">Book 3</option>
            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.book}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="user" className=' me-3 ms-3 pt-3'>
            <Form.Label>User</Form.Label>
            <Form.Control
              as="select"
              name="user"
              value={formData.user}
              onChange={handleInputChange}
              isInvalid={!!errors.user}
            >
              <option value="">Select User</option>
              <option value="User 1">User 1</option>
              <option value="User 2">User 2</option>
              <option value="User 3">User 3</option>
            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.user}
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
      </div>

      <div className="d-flex justify-content-between mt-3">
        <Button variant="primary" type="submit" onClick={handleSubmit}>
          Submit
        </Button>
        <Button variant="secondary" type="button">
          Cancel
        </Button>
      </div>

      <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
        <Modal.Body>
          <Alert variant="success">Form submitted successfully!</Alert>
        </Modal.Body>
        <Button variant="secondary" onClick={() => setShowSuccessModal(false)}>
          Close
        </Button>
      </Modal>

      <Modal show={showErrorModal} onHide={() => setShowErrorModal(false)} centered>
        <Modal.Body>
          <Alert variant="danger">Failed to submit form. Please try again.</Alert>
        </Modal.Body>
        <Button variant="secondary" onClick={() => setShowErrorModal(false)}>
          Close
        </Button>
      </Modal>
    </Card>
  );
};

export default AddBookIssueForm;
